// NotAvailableTab.tsx
import React, { useContext } from "react";
import { Box } from "@mui/material";
import MedintTable from "../../../MedintTable/MedintTable";
import { MedintTableProps } from "../../../MedintTable/MedintTable";
import { MedintDataContext } from "../../../../Context/MedintContextWrapper";
import { NonDisponibilita } from "../../../../../../services/medintInterfaces";
import { formatHour } from "../../../../../AppointmentResearch/AppointmentResearch";
import dayjs from "dayjs";

const NotAvailableTab: React.FC<
  Pick<MedintTableProps, "onEditClick" | "onCopyClick" | "onDeleteClick" | "fetchDataMedico">
> = ({ onEditClick, onCopyClick, onDeleteClick, fetchDataMedico  }) => {
  const context = useContext(MedintDataContext);
  const headers = [
    "Data Indisponibilità",
    "Ora Inizio",
    "Ora Fine",
    "Descrizione",
  ];

  const data =
    context?.doctorAgenda.nondisponibilita !== undefined
      ? context?.doctorAgenda.nondisponibilita.map((e: NonDisponibilita) => {
          return {
            "Data Indisponibilità": dayjs(e.DATANODISP).format(`DD/MM/YYYY`),
            "Ora Inizio": formatHour(e.ORAINIZIONODISP),
            "Ora Fine": formatHour(e.ORAFINENODISP),
            Descrizione: e.DSCNODISP,
            idPanodi: e.IDPANODI
          };
        })
      : [
          {
            "Data Indisponibilità": "—",
            "Ora Inizio": "—",
            "Ora Fine": "—",
            Descrizione: "—",
          },
        ];

  return (
    <Box mt={2}>
      <MedintTable
        headers={headers}
        data={data}
        showActionButton
        onCopyClick={onCopyClick}
        onDeleteClick={onDeleteClick}
        fetchDataMedico={fetchDataMedico}
      />
    </Box>
  );
};

export default NotAvailableTab;
